module.exports = __webpack_public_path__ + "img/蒙版(22).6197d600.png";